/**
 * A simple implementation of sessionStorage which uses JSON APIs
 * to encode and decode JSON objects.
 * */

const SmartSessionStorage = {
  set(name: string, value: unknown) {
    if (!window) throw Error('Method can only be used on client');
    try {
      window.sessionStorage.setItem(name, JSON.stringify(value));
    } catch {}
  },
  get(name: string) {
    if (!window) throw Error('Method can only be used on client');
    try {
      const value = window.sessionStorage.getItem(name);
      return value ? JSON.parse(value) : null;
    } catch {
      return null;
    }
  },
  remove(name: string) {
    if (!window) throw Error('Method can only be used on client');
    try {
      window.sessionStorage.removeItem(name);
    } catch {}
  },
  clear() {
    if (!window) throw Error('Method can only be used on client');
    try {
      window.sessionStorage.clear();
    } catch {}
  },
};

export { SmartSessionStorage };
